import { render, staticRenderFns } from "./SupplierPricesList.vue?vue&type=template&id=0766d648"
import script from "./SupplierPricesList.vue?vue&type=script&lang=js"
export * from "./SupplierPricesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0766d648')) {
      api.createRecord('0766d648', component.options)
    } else {
      api.reload('0766d648', component.options)
    }
    module.hot.accept("./SupplierPricesList.vue?vue&type=template&id=0766d648", function () {
      api.rerender('0766d648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/supplier-prices/SupplierPricesList.vue"
export default component.exports